<div class="tools-container" *ngIf="sidebar" [ngClass]="{ reduced: !sidebar.active }">
  <!-- PLANTILLAS WEB -->
  <div class="tool" *ngIf="toolsConfig.color">
    <button (click)="onToolSelected('colors')" [ngClass]="{ active: sidebar.active === 'colors' }">
      <div>
        <div class="ico-wrapper">
          <img src="/assets/img/tools/colors.svg" alt="{{ toolsName['colors'] }}" />
        </div>
        <span *ngIf="sidebar.active">{{ toolsName['colors'] }}</span>
      </div>
    </button>
  </div>
  <!--- CABECERA : HEADER / SUBHEADER / BUY TICKETS / LOGO-FAVICON -->
  <div class="tool" *ngIf="toolsConfig.titles && toolsConfig.logo">
    <button (click)="onToolSelected('header')" [ngClass]="{ active: sidebar.active === 'header' }">
      <div>
        <div class="ico-wrapper">
          <img src="/assets/img/tools/header.svg" alt="{{ toolsName['header'] }}" />
        </div>
        <span *ngIf="sidebar.active">{{ toolsName['header'] }}</span>
      </div>
    </button>
  </div>
  <!--- POPUPS : LOOK&FEEL / INFO / COMPARATOR-->
  <div class="tool" *ngIf="toolsConfig.popups">
    <button (click)="onToolSelected('popups')" [ngClass]="{ active: sidebar.active === 'popups' }">
      <div>
        <div class="ico-wrapper">
          <img src="/assets/img/tools/popups.svg" alt="" />
        </div>
        <span *ngIf="sidebar.active">{{ toolsName['popups'] }}</span>
      </div>
    </button>
  </div>
  <!--- BUSCADOR -->
  <div class="tool" *ngIf="toolsConfig.searcher">
    <button (click)="onToolSelected('searcher')" [ngClass]="{ active: sidebar.active === 'searcher' }">
      <div>
        <div class="ico-wrapper">
          <img src="/assets/img/tools/searcher.svg" alt="" />
        </div>
        <span *ngIf="sidebar.active">{{ toolsName['searcher'] }}</span>
      </div>
    </button>
  </div>
  <!--- MAPA : LOOK&FFEL / PLUGINS: [BEST NODES / ZOOM / PANNING]  / MINIMAPA-->
  <div
    class="tool"
    *ngIf="
      toolsConfig.colormap ||
      toolsConfig.zooming ||
      toolsConfig.panning ||
      toolsConfig.bestnode ||
      toolsConfig.minimap ||
      toolsConfig.availability ||
      toolsConfig.layers
    ">
    <button (click)="onToolSelected('map')" [ngClass]="{ active: sidebar.active === 'map' }">
      <div>
        <div class="ico-wrapper">
          <img src="/assets/img/tools/map.svg" alt="" />
        </div>
        <span *ngIf="sidebar.active">{{ toolsName['map'] }}</span>
      </div>
    </button>
  </div>
  <!--- PANOS / 3D VIEWS : VPANOS / PLUGINS: [INDOOR, MULTIINDOOR, NAVIGATION] / VIEWER-->
  <div
    class="tool"
    *ngIf="
      toolsConfig.fullscreen ||
      toolsConfig.copylink ||
      toolsConfig.indoor ||
      toolsConfig.navigation
    ">
    <button (click)="onToolSelected('plugins')" [ngClass]="{ active: sidebar.active === 'plugins' }">
      <div>
        <div class="ico-wrapper">
          <img src="/assets/img/tools/plugins.svg" alt="" />
        </div>
        <span *ngIf="sidebar.active">{{ toolsName['plugins'] }}</span>
      </div>
    </button>
  </div>
  <!--- CONFIGURACIONES: REUNION REQUIRED -->
  <div class="tool" *ngIf="toolsConfig.multivenue">
    <button (click)="onToolSelected('multivenue')" [ngClass]="{ active: sidebar.active === 'multivenue' }">
      <div>
        <div class="ico-wrapper">
          <img src="/assets/img/tools/multivenue.svg" alt="" />
        </div>
        <span *ngIf="sidebar.active">{{ toolsName['multivenue'] }}</span>
      </div>
    </button>
  </div>
  <!--- FILTROS / MENU : TYPE / ESPECS.-->
  <div class="tool" *ngIf="toolsConfig.filters">
    <button (click)="onToolSelected('filters')" [ngClass]="{ active: sidebar.active === 'filters' }">
      <div>
        <div class="ico-wrapper">
          <img src="/assets/img/tools/filters.svg" alt="" />
        </div>
        <span *ngIf="sidebar.active">{{ toolsName['filters'] }}</span>
      </div>
    </button>
  </div>

  <!--- FICHEROS EXTERNOS : TRANSLATION / NEIGHBORS-->
  <div class="tool" *ngIf="toolsConfig.translation || toolsConfig.neighbours || toolsConfig.exceptions">
    <button (click)="onToolSelected('extern')" [ngClass]="{ active: sidebar.active === 'extern' }">
      <div>
        <div class="ico-wrapper">
          <img src="/assets/img/tools/extern.svg" alt="" />
        </div>
        <span *ngIf="sidebar.active">{{ toolsName['extern'] }}</span>
      </div>
    </button>
  </div>

  <!-- VIP INFO -->
  <div class="tool" *ngIf="toolsConfig.vipinfo">
    <button (click)="onToolSelected('vipinfo')" [ngClass]="{ active: sidebar.active === 'vipinfo' }">
      <div>
        <div class="ico-wrapper">
          <img src="/assets/img/tools/copylink.svg" alt="" />
        </div>
        <span *ngIf="sidebar.active">{{ toolsName['vipinfo'] }}</span>
      </div>
    </button>
  </div>

  <!-- DISCLAIMER -->
  <div class="tool" *ngIf="toolsConfig.disclaimer">
    <button (click)="onToolSelected('disclaimer')" [ngClass]="{ active: sidebar.active === 'disclaimer' }">
      <div>
        <div class="ico-wrapper">
          <img src="/assets/img/tools/disclaimer.svg" alt="" />
        </div>
        <span *ngIf="sidebar.active">{{ toolsName['disclaimer'] }}</span>
      </div>
    </button>
  </div>

  <!-- LANGUAGE -->
  <div class="tool" *ngIf="toolsConfig.language">
    <button (click)="onToolSelected('language')" [ngClass]="{ active: sidebar.active === 'language' }">
      <div>
        <div class="ico-wrapper">
          <img src="/assets/img/tools/language.svg" alt="" />
        </div>
        <span *ngIf="sidebar.active">{{ toolsName['language'] }}</span>
      </div>
    </button>
  </div>
</div>